"use client";

import * as React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { ISMSRoleCombobox } from "../components/ui/ISMSRoleCombobox";

export function ISMSRoleComboboxExample() {
  const [selectedRoles, setSelectedRoles] = React.useState<string[]>([]);
  
  // Example of programmatically setting selected roles
  const setExampleRoles = () => {
    setSelectedRoles(['role-1', 'role-2']);
  };
  
  // Clear all selected roles
  const clearAll = () => {
    setSelectedRoles([]);
  };
  
  // Handle when a role is selected
  const handleRoleSelect = (roleId: string) => {
    console.log(`Role selected: ${roleId}`);
  };
  
  // Handle when a role is deselected
  const handleRoleDeselect = (roleId: string) => {
    console.log(`Role deselected: ${roleId}`);
  };
  
  // Example of custom roles data (optional)
  const customRoles = [
    { id: 'role-1', roleName: 'Information Security Manager' },
    { id: 'role-2', roleName: 'Risk Manager' },
    { id: 'role-3', roleName: 'Compliance Officer' },
    { id: 'role-4', roleName: 'Data Protection Officer' },
  ];
  
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>ISMS Role Combobox</CardTitle>
          <CardDescription>
            A combobox component for selecting ISMS roles.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <h3 className="text-sm font-medium">Basic Usage</h3>
            <ISMSRoleCombobox
              selected={selectedRoles}
              setSelected={setSelectedRoles}
              onRoleSelect={handleRoleSelect}
              onRoleDeselect={handleRoleDeselect}
              className="w-full"
            />
          </div>
          
          <div className="space-y-2">
            <h3 className="text-sm font-medium">With Custom Roles</h3>
            <ISMSRoleCombobox
              selected={selectedRoles}
              setSelected={setSelectedRoles}
              roles={customRoles}
              className="w-full"
              singleSelect={true}
            />
          </div>
          
          <div className="flex space-x-2 pt-2">
            <Button variant="outline" size="sm" onClick={setExampleRoles}>
              Set Example Roles
            </Button>
            <Button variant="outline" size="sm" onClick={clearAll}>
              Clear All
            </Button>
          </div>
          
          <div className="pt-4">
            <h3 className="text-sm font-medium mb-2">Selected Roles:</h3>
            <div className="space-y-2">
              {selectedRoles.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {selectedRoles.map((roleId) => {
                    const role = [...customRoles].find(r => r.id === roleId);
                    return (
                      <Badge key={roleId} variant="secondary">
                        {role ? role.roleName : roleId}
                      </Badge>
                    );
                  })}
                </div>
              ) : (
                <p className="text-sm text-muted-foreground">No roles selected</p>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
